// extracted by mini-css-extract-plugin
export default {"legalAgreement":"LegalAgreement_legalAgreement__gWLgk","link":"LegalAgreement_link__4IKOT"};